import React from 'react';
import QuestionProgress from "./QuestionProgress";
import Questions from "./Questions";
import QuestionHeader from "./QuestionHeader";
import QuestionAudioPlayer from "./QuestionAudioPlayer";
import $ from 'jquery';
import Loader from "./loader";

class Quiz extends React.Component{


    constructor(props) {
        super(props);
        this.state = {
            language:this.props.data[0].field_language,
            question:{
                index:0,
                questionId:1,
                timer:this._sec2time(this.props.data[0].field_timer),
               /* timerStart:false,
                audioUrl:this.props.data[0].field_audio_file,
                audio:new Audio(this.props.data[0].field_audio_file),*/

               /* disabledNext: true,
                timerUpdated:0,*/
            },
            ques: this.props.data[0],
            /*index: 0,*/
            disabledNext: true,
            currentWidth:0,
            percentage:1,
            timerUpdated:this._sec2time(this.props.data[0].field_timer),
            audioUrl:this.props.data[0].field_audio_file,
            audio:new Audio(this.props.data[0].field_audio_file),
            answerMode:true,
            disabledSpinner:false,




        }
        this.audioChild = React.createRef();
        this.questionChild = React.createRef();





    }

    _shuffle(option){
        for(var j, x, i = option.length; i; j = Math.floor(Math.random() * i), x = option[--i], option[i] = option[j], option[j] = x);
        return option;
    }

    _nextQuestion(){

        if(!this.state.ques["title"].includes('Frage 13')){
        //if(this.state.ques["title"] != this.state.language+" Frage 13") {
            let width = this.state.percentage;
            this.setState({percentage: width + this.state.currentWidth});
        }

        let e = document.getElementsByClassName('col-options2');
        for (let i = 0; i < e.length; i++) {
            e[i].removeAttribute('checked')
            e[i].setAttribute('class','col-options2')
        }
        let el = document.getElementsByClassName('col-options3');
        for (let i = 0; i < el.length; i++) {
            el[i].removeAttribute('checked')
            el[i].setAttribute('class','col-options3')
        }

      /* let question = JSON.stringify(this.state.ques['field_question']);*/
      let qStr='', additionalQStr='';
        this.state.ques['field_question'].map((title,key)=>{
            if(title.includes('<p>')){
                qStr += title;
            }else {
                qStr += '<p>' + title + '</p>'
            }
        });

       let question = qStr;
       let questionType = this.state.ques['field_question_type'];
      /* let additionalQuestion = this.state.ques['field_additional_question'].toString();*/
      /* let additionalQuestion = JSON.stringify(this.state.ques['field_additional_question']);*/
       let additionalQuestion = this.state.ques['field_additional_question'];
       let additionalAnswers = this.state.ques['field_additional_answers'];
       let possibleAnswers = this.state.ques['field_answers'];
      /* console.log(possibleAnswers)*/
       let correctAnswer = parseInt(this.state.ques['field_correct_answer']);
       let additionalCorrectAnswer = parseInt(this.state.ques['field_correct_answer_additional']);
       let multipleQuestion = this.state.ques['field_multiple_questions'];

       /*console.log(this.state.ques['title'])
       console.log(this.state.ques)*/
        if(this.state.ques.field_drag_drop=="1"){
            let dragDropOptions = [];
            let dragDropOptionsTitle = [];
           /* $("select.drag-and-drop").each(function(){
                dragDropOptions.push($(this).val());
                dragDropOptionsTitle.push($(this).children("option").filter(":selected").text());
            });*/
            $("input.dragDrop").each(function(){
                dragDropOptionsTitle.push($(this).val());
                dragDropOptions.push($(this).attr("id"));
            });
            /*console.log(dragDropOptionsTitle)
            console.log(dragDropOptions)*/
            let param=[
                question,
                possibleAnswers,
                dragDropOptions,
                dragDropOptionsTitle,
                questionType,
                multipleQuestion
            ]
            this.questionChild.current._updateDnDArr(param);

        }else if(this.state.ques.field_gap_question=="1"){
            let gapOptions = [];
            let gapOptionsTitle = [];
            $("input.gap").each(function(){
                gapOptions.push($(this).val().trim().toLowerCase());
            });
            /*console.log(gapOptions);*/
            let param=[
                question,
                possibleAnswers,
                gapOptions,
                gapOptionsTitle,
                questionType,
                multipleQuestion
            ]
            this.questionChild.current._updateGapArr(param);
        }else if(this.state.ques.field_multiple_choice_ques=="1"){
            let param=[
                question,
                possibleAnswers[0],
                additionalQuestion,
                additionalAnswers,
                correctAnswer,
                additionalCorrectAnswer,
                questionType,
                multipleQuestion
            ];
            this.questionChild.current._updateMCArr(param);

        }else if(this.state.ques.field_multiple_questions=="1"){
            let param=[
                question,
                possibleAnswers,
                additionalQuestion,
                additionalAnswers,
                correctAnswer,
                additionalCorrectAnswer,
                questionType,
                multipleQuestion
            ];
            this.questionChild.current._updateMQArr(param);

        }else {
            this.questionChild.current._updateArr(question,possibleAnswers,correctAnswer,questionType);
        }
       /* console.log('in quiz nextQ')
        console.log(this.state.ques)
        console.log(this.tutorialInput.clientHeight)*/

      /*  this.setState({question:""})*/
        /*console.log('end')*/

    }
    componentDidMount() {
        window.parent.postMessage({'width': document.body.scrollWidth, 'height': document.body.scrollHeight}, '*');
        this._getQuestionWidth(this.tutorialInput.clientWidth);
        this.audioChild.current._start();
        /*console.log(window.innerWidth)*/
       /* if(window.innerWidth>=768) {*/
            window.addEventListener('scroll', this.handleScroll.bind(this));
     /*   }*/


       /* if (window.addEventListener) {
            window.addEventListener("message", this.iframeQuizInfo, false);
        } else {
            window.attachEvent("onmessage", this.iframeQuizInfo());
        }*/

    }

    handleScroll(event) {
       /* console.log('in handlescroll')*/
        if(window.pageYOffset === 0) {
          /*  this.quizHeader.style.transition = "top 3s ease-out"*/
            this.quizHeader.style.top = null;

        }else {
          /*  this.quizHeader.style.transition = "top 3s ease-out"*/
            this.quizHeader.style.top = "0px";

        }
    }

    _getQuestionWidth (quizWidth){
        let currentWidth = quizWidth/13;
        this.setState({currentWidth:currentWidth});
        this.setState({percentage:currentWidth});
    }
    _sec2time(timeInSeconds){
        var pad = function(num, size) { return ('000' + num).slice(size * -1); },
            time = parseFloat(timeInSeconds).toFixed(3),
            minutes = Math.floor(time / 60) % 60,
            seconds = Math.floor(time - minutes * 60);

        return pad(minutes, 2) + ':' + pad(seconds, 2);
    }
    _handleStateChange(indexNr,disabledNext){
        if(indexNr<13) {
            this.setState({
                question: {
                    index: indexNr,
                    questionId: indexNr + 1,
                    timer: this._sec2time(this.props.data[indexNr].field_timer),
                    audio: this.props.data[indexNr].field_audio_file ? new Audio(this.props.data[indexNr].field_audio_file) : '',
                    audioUrl: this.props.data[indexNr].field_audio_file ? this.props.data[indexNr].field_audio_file : '',
                },
                audio: this.props.data[indexNr].field_audio_file ? new Audio(this.props.data[indexNr].field_audio_file) : '',
                audioUrl: this.props.data[indexNr].field_audio_file ? this.props.data[indexNr].field_audio_file : '',
                timerUpdated: this._sec2time(this.props.data[indexNr].field_timer),
                disabledNext: true,
            });
            this.setState({ques: this.props.data[indexNr]}, () => {
               /* this.state.ques['field_answers'] = ['abc','xyz']*/
                /*this._shuffle(this.state.ques['field_answers'])
                if(this.state.ques['field_additional_answers'] != "") {
                    console.log('hi toggle')
                    this._shuffle(this.state.ques['field_additional_answers'])
                }*/
            });

        }else{
            /*this.setState({question:""})*/
           /* this.setState({ques:""})*/
        }

    }

   /* iframeQuizInfo(evt) {
        console.log('in iframe quiz info')
        let message;
        message = "LISTNER from react-app: Height - " + evt.data.height + " LISTNER: Width - " + evt.data.width;
        console.log(message);
    }*/

    toggleNext(e) {

       /* setTimeout(()=> {
            console.log('in quiz')
            console.log(document.body.scrollHeight)
        },500);*/
       /* window.parent.postMessage({'width': window.innerWidth, 'height': window.innerHeight}, '*');
        console.log(document.body.scrollHeight)*/
        let indexNr = parseInt(this.state.question.index) + 1;
        /*console.log('IndexNr = ' +indexNr)*/
        let disabledNext = false
       /* if (indexNr === this.props.data.length - 1) {
            e.preventDefault()
            indexNr = this.props.data.length - 1
            disabledNext = true
        }*/
        this._nextQuestion();
        setTimeout(()=> {
            this._handleStateChange(indexNr, disabledNext);
           /* console.log(this.state.question)
            console.log(this.state.ques)
            console.log('in quiz')*/
            /*console.log(document.body.scrollHeight)*/
            window.parent.postMessage({'width': document.body.scrollWidth, 'height': document.body.scrollHeight}, '*');
        },500);
        setTimeout(()=> {
           if(this.state.audio!="") {
               this.state.audio.pause()
           }
            this.audioChild.current._start(indexNr+1);

        },400);

       /* console.log(indexNr)*/

        if (indexNr === this.props.data.length) {
           /* console.log('end btn clicked')*/
            this.setState({disabledNext:true});
            this.setState({disabledSpinner:true});
            setTimeout(()=> {
              /*  console.log('submitting ans');*/
                this.submitAnswer();
            },1000);

        }
      /*  if (indexNr === this.props.data.length - 1) {
           console.log('last q')
        }*/

        $('html,body').animate({
                scrollTop: $(".tutorial").offset().top},
            'slow');

    }
   /* setResultDisabled(){
        return this.state.disabledEnd;
    }*/

    setDisabled(val,disabled){
        if(disabled){
            this.setState({ disabledNext: val }, () => {
                return this.state.disabledNext;
            });

        }else {
            return this.state.disabledNext;
        }
    }

    _updateTimer(changedTimer){
        this.setState({timerUpdated:changedTimer}, () => {
            if(this.state.timerUpdated == "00:00"){
                this.toggleNext()
            }
        });
    }
    submitAnswer(e) {
     /*   this.setState({answerMode:false})*/
       /* console.log('end')*/
        this.questionChild.current._getAllResults()
    }

    /*_randomArr(){
        let ans = this._shuffle(this.state.ques['field_answers'])
        console.log(ans);
        return ans;
    }
    _randomAdditionalArr(){
        return this._shuffle(this.state.ques['field_additional_answers'])
    }*/


    render() {

        /*console.log(this.props.paramData);
        console.log(Object.keys(this.props.paramFrame).length);
*/
      /*  console.log(this.props.paramFrame);*/
       /* console.log(this.state.ques)*/
       let classname = this.state.disabledNext? " btn btn-primary no":"btn btn-primary yes";
       //let endclassname = this.state.disabledEnd? " btn btn-primary no":"btn btn-primary yes";
       /*let mainOptions = this._randomArr();
       let additionalOptions = this._randomAdditionalArr();*/
       const results = this.props.data;

        if (results) {
            let count = results.length;
            const {index, disabledNext} = this.state.question;
            const question = results ? results[index] : null;

        /*    console.log(question)*/
            if (question) {
                const questionHeader = {
                    questionId: this.state.question.questionId,
                    totalQuestion: count,
                };
                const questionAudio = {
                    questionId: this.state.question.questionId,
                    audio: this.state.audio,
                    audioUrl: this.state.audioUrl,
                };
                return (
                    <div className='tutorial'>
                        <div className="quizHead" ref={input => {this.quizHeader = input;}}>
                            <QuestionProgress percentage={this.state.percentage}/>
                            <QuestionHeader questionHeader={questionHeader}
                                            timerUpdated={this.state.timerUpdated}
                                            timer={this.state.question.timer}/>
                        </div>
                        <div className='quiz' ref={input => {
                            this.tutorialInput = input;
                        }}>
                            <QuestionAudioPlayer
                                ref={this.audioChild}
                                questionAudio={questionAudio}
                                updateTimer={this._updateTimer.bind(this)}
                                timerUpdated={this.state.timerUpdated}
                                timer={this.state.question.timer}
                                paramFrame={this.props.paramFrame}/>

                            <div className='quiz-area' id="quiz-area">
                                <Questions question={this.state.ques}
                                           language={this.state.language}
                                           paramData={this.props.paramData}
                                           paramFrame={this.props.paramFrame}
                                          /* mainOptions={mainOptions}
                                           additionalOptions={additionalOptions}*/
                                          /* qArr={this.state.qArr}*/
                                           ref={this.questionChild}
                                           setDisabled={this.setDisabled.bind(this)}

                                />
                            </div>
                            {this.state.question.questionId!=13?
                            <div className="NextButton">
                                <button type="button"
                                        className={classname}
                                        onClick={this.toggleNext.bind(this)}
                                       /* disabled={this.state.disabledNext}>*/
                                        disabled={this.setDisabled()}>
                                    Nächste Frage
                                </button>
                            </div> :
                            <div className="FinishButton">
                               {/* <h2>Der Test ist zu Ende.</h2>*/}

                                {this.state.disabledSpinner?
                                    <Loader/> :
                                    <button type="button"
                                            className={classname}
                                            onClick={this.toggleNext.bind(this)}
                                            disabled={this.setDisabled()}>
                                        Test abschließen
                                    </button>
                                }
                            </div>

                            }

                        </div>
                    </div>
                );
            } else {
                return (
                    <div className='tutorial'>
                        <div className="quizHead">
                           {/* <QuestionProgress percentage={this.state.percentage}/>
                            <QuestionHeader questionHeader={questionHeader}
                                            timerUpdated={this.state.timerUpdated}
                                            timer={this.state.question.timer}/>*/}
                        </div>
                        <div className='quiz' ref={input => {
                            this.tutorialInput = input;
                        }}>
                            {/*<QuestionAudioPlayer
                                ref={this.audioChild}
                                questionAudio={questionAudio}
                                updateTimer={this._updateTimer.bind(this)}
                                timerUpdated={this.state.timerUpdated}
                                timer={this.state.question.timer}/>*/}

                            <div className='quiz-area' id="quiz-area">
                                <Questions question={this.state.ques}
                                    /* qArr={this.state.qArr}*/
                                           ref={this.questionChild}
                                    /*getSelectedAnswer={this._getSelectedAnswer.bind(this)}*/

                                />
                                <div className="resultButton">
                                     <h2>Der Test ist zu Ende.</h2>
                                    <button type="button"
                                            className="btn btn-primary"
                                            onClick={this.submitAnswer.bind(this)}
                                            disabled={this.nextDisabled()}>
                                        Zum Ergebnis
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                )
            }
        }
    }

}
export default Quiz;
